import { auth } from '../firebase';

const API_BASE = import.meta.env.VITE_API_BASE as string;

export interface UploadResult {
  uploadId: string;
  r2Key: string;
  signedUrl: string;
  mimeType: string;
  sizeBytes: number;
}

export async function uploadImage(file: File): Promise<UploadResult> {
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');
  const token = await user.getIdToken();

  const fd = new FormData();
  fd.append('image', file, file.name);

  const res = await fetch(`${API_BASE}/api/uploads`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: fd,
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) msg = body.error;
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }
  return (await res.json()) as UploadResult;
}
